export type UnifiedColumn = {
  id: string;
  name: string;
  field: string;
  sortable: boolean;
  visible: boolean;
};

const COLUMN_WEIGHT = new Map([
  ['titulo', 11],
  ['processDefinitionName', 9],
  ['processInstanceTitle', 11],
  ['taskName', 10],
  ['assignee', 9],
  ['startTime', 10],
  ['endTime', 10],
  ['state', 6],
  ['initiator', 8],
  ['accessReasons', 12],
]);

export const TEXT_TOOLTIP_COLUMN_IDS = new Set([
  'titulo',
  'processDefinitionName',
  'processInstanceTitle',
  'taskName',
  'assignee',
  'initiator',
]);

export function getColumnWidthPercent(columnId: string, columns: UnifiedColumn[]) {
  const weights = columns.map((col) => COLUMN_WEIGHT.get(col.id) ?? 7);
  const totalWeight = weights.reduce((sum, weight) => sum + weight, 0);
  const columnIndex = columns.findIndex((col) => col.id === columnId);
  if (columnIndex === -1 || totalWeight === 0) {
    return '10%';
  }
  return `${((weights[columnIndex] / totalWeight) * 100).toFixed(4)}%`;
}

export function getHeadClassName(columnId: string) {
  return [
    'sticky top-0 z-10 bg-background px-1.5 py-2 text-center text-xs font-semibold shadow-[0_1px_0_0_hsl(var(--border))]',
    (columnId === 'startTime' || columnId === 'endTime') && 'px-2',
  ].filter(Boolean).join(' ');
}

export function isMultilineHeaderColumn(columnId: string) {
  return columnId === 'startTime' || columnId === 'endTime';
}

export function getCellClassName(column: UnifiedColumn) {
  return [
    'overflow-hidden px-1.5 py-1 align-top',
    (column.id === 'startTime' || column.id === 'endTime' || column.id === 'state' || column.id === 'accessReasons') && 'text-center',
    column.id === 'processDefinitionName' && 'font-medium',
  ].filter(Boolean).join(' ');
}
